import FormSectionTitle from "../../components/styled/FormSectionTitle";
import { useGetAllCarInfoByCarInfoTypeSlug } from "../../utils/carInfo.utils";
import MoneyReceiptSection from "./MoneyReceiptSection";

export default function CarDeliveryInfo({ watch, control, errors, unregister, setValue, others }) {
  const { data: services, serviceLoading } = useGetAllCarInfoByCarInfoTypeSlug("customer-services");

  const { data: papers, papersLoading } = useGetAllCarInfoByCarInfoTypeSlug("customer-papers");

  const fields = [
    {
      label: "Delivery Services",
      name: "customer.delivery_services",
      type: "select",
      placeholder: "Select delivery services",
      col: { md: 12 },
      isMulti: true,
      options: services
    },
    {
      label: "Delivery Papers",
      name: "customer.delivery_papers",
      type: "select",
      placeholder: "Select delivery papers",
      col: { md: 12 },
      isMulti: true,
      options: papers
    },
    {
      label: "Expected Delivery Date",
      name: "customer.expected_delivery_date",
      type: "datetime",
      placeholder: "Select a date",
      col: { md: 4 }
    }
  ];

  const isLoading = serviceLoading || papersLoading;

  return (
    <MoneyReceiptSection
      setValue={setValue}
      fields={fields}
      control={control}
      watch={watch}
      errors={errors}
      loading={isLoading}>
      <div className="col-12">
        <FormSectionTitle>Delivery Information</FormSectionTitle>
      </div>
    </MoneyReceiptSection>
  );
}
